/**
 * Interface for JWT token payload
 */
export interface IJwtTokenPayload {
  sEmail: string;
  tOrganizations: string[];
  tRole: string;
  tDepartment: string;
  tDesignation: string;
  tShifts?: string[];
  bCanLogin: boolean;
  bIsActive: boolean;
  bOnlyOfficePunch: boolean;
  bIsCreatedBySuperAdmin: boolean;
  bIsPermanentWFH: boolean;
  bIsAdmin: boolean;
  exp?: number;
  iat?: number;
}

/**
 * Decodes a JWT token and returns the payload
 * @param token - The JWT token to decode
 * @returns The decoded payload or null if invalid
 */
export function decodeJwtToken(token: string): IJwtTokenPayload | null {
  try {
    // JWT tokens have 3 parts separated by dots: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];

    // Add padding if needed for base64 decoding
    const paddedPayload = payload + '='.repeat((4 - (payload.length % 4)) % 4);

    // Decode from base64
    const decodedPayload = atob(paddedPayload);

    // Parse JSON
    return JSON.parse(decodedPayload) as IJwtTokenPayload;
  } catch {
    return null;
  }
}
